import type { PluginListenerHandle } from '@capacitor/core';
import { Capacitor } from '@capacitor/core';
import { Keyboard, type KeyboardInfo } from '@capacitor/keyboard';
import { useEffect } from 'react';
import { useKeyboardStore } from '../stores/keyboard';

export const useKeyboardListeners = () => {
  const setKeyboardState = useKeyboardStore((state) => state.setKeyboardState);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let showListener: PluginListenerHandle | null = null;
    let hideListener: PluginListenerHandle | null = null;

    const addListeners = async () => {
      try {
        showListener = await Keyboard.addListener(
          'keyboardWillShow',
          (info: KeyboardInfo) => {
            setKeyboardState(true, info.keyboardHeight);
          },
        );

        hideListener = await Keyboard.addListener('keyboardWillHide', () => {
          setKeyboardState(false, 0);
        });
      } catch (error) {
        console.error('Failed to add keyboard listeners:', error);
      }
    };

    addListeners();

    return () => {
      if (showListener) {
        showListener.remove();
      }
      if (hideListener) {
        hideListener.remove();
      }
    };
  }, [setKeyboardState]);
};
